const blockAttributes = {
	title: {
		type: "string",
		default: "Pay with Flutterwave",
	},
	justify: {
		type: "string",
	},
	alignment: {
		type: "string",
	},
	buttontext: {
		type: "string",
		selector: "h6",
	},
	fontsize: {
		type: "string",
		default: "17px",
	},
	backgroundcolor: {
		type: "string",
		default: "#F5A623",
	},
	textcolor: {
		type: "string",
		default: "#FFFFFF",
	},
};

export default blockAttributes;
